/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { isEmpty as _isEmpty } from 'lodash';
import { useParams, useHistory } from 'react-router-dom';

// @material-ui
import { Box, Button, Paper, Typography } from '../../../components/shared/MaterialUI';

// @state
import { QuestionnaireContext } from '../Prescreening';
import { useUI } from '../../../app/context/ui';

// @assets
import AppHelper from '../../../helpers/AppHelper';
import { ThankyouStyles } from '../../../assets/css/questionnaire-style';

// @services
import QuestStartServiceNewApi from '../../../services/newApi/QuestionnaireServiceNewApi';

// @components
import DriverLicense from './DriverLicense';
import { theme } from '../../../assets/theme';

// @helpers

const ThankYou = () => {
  const {
    initial,
    t,
    companyLogo,
    lang,
    updateQuestion
  } = useContext(QuestionnaireContext);
  const { messages, confirmationCode } = initial;
  const questService = useMemo(() => new QuestStartServiceNewApi(), []);
  const style = useMemo(() => ThankyouStyles(),[]);
  const { hashToken } = useParams();
  const { blockUI, snackbarUI } = useUI();
  const firstRender = useRef(true);
  const history = useHistory();

  const callWebhook = async () => {
    try {
      blockUI.current.open(true);
      await questService.callWebhook(hashToken)
      blockUI.current.open(false);
    } catch (error) {
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }
  
  useEffect(() => {
    if (firstRender.current) {
      callWebhook();
      firstRender.current = false;
    }
  }, [initial]);

  const nextPage = () => {
    if(initial?.isVeteran && !initial?.hasDD214Answer)return history.push(`/upload-file-dd214/${hashToken}?lang=${lang}`);
    //if(initial.obRedirectLink)return redirectToBulkhorn(initial?.obRedirectLink);
    return history.push(`/upload-file-dd214/${hashToken}?lang=${lang}`);
  }

  return (
    <>
      <Box sx={{...style.containerThanks, top: companyLogo ? '150px' : "60px" }}>
        {!initial?.hasDriverLicenseFile && (initial?.isEZ || initial?.isRRC)
          ? <DriverLicense
              lang={lang}
              hashToken={hashToken}
              updateQuestion={updateQuestion}
              initial={initial}
            />
          : <Paper elevation={0} sx={style.paperThanks}>
              <Box sx={style.containerText}>
                <Typography variant='h1' sx={style.textGreat}>
                  {t("question.great")}
                </Typography>

                {!_isEmpty(messages)
                  ? ( <>
                        <Typography variant="body1" sx={style.textStatus}>
                          {messages.statusMessage}.
                        </Typography>
                      </>)
                  : ('')
                }
                <>
                  <Typography variant="body1" sx={style.textStatus}>
                    {t("question.codeConfirmation")} {confirmationCode}.
                  </Typography>

                  {((!initial?.isVeteran || initial.hasDD214Answer) && !initial.obRedirectLink) &&
                    <Typography variant="body1" sx={style.textStatus}>
                        {t("question.closeWindow")}
                    </Typography>
                  }

                  {/*This comment was made when the employee was coming from Bulkhor and was redirected when this ended */}
                  {/*{((initial?.isVeteran && !initial?.hasDD214Answer)|| initial.obRedirectLink) &&*/}                  
                  {(initial?.isVeteran && !initial?.hasDD214Answer) &&
                    <Button
                      variant='contained'
                      onClick={nextPage}
                      sx={{
                        color: theme.palette.primary.white,
                        backgroundColor: theme.palette.primary.black,
                        '&: hover': {backgroundColor: theme.palette.secondary.black},
                        height: '40px'
                      }}
                    >
                      Next
                    </Button>
                  }
                </>
              </Box>
            </Paper>
        }
      </Box>
      <Box sx={style.emptyContainer} />
    </>

  
  );
};

export default ThankYou;
